var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.655,423.723H38.345C17.167,423.723,0,406.556,0,385.378V126.62 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345v258.759 C512,406.556,494.833,423.723,473.655,423.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC8FF"
    },
    d: "M256.057,167.723c-33.549,17.651-56.175,59.69-56.175,88.276s22.626,70.626,56.175,88.276 c33.549-17.651,56.175-59.69,56.175-88.276S289.607,185.373,256.057,167.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M263.302,225.772c5.42-2.857,14.674-6.001,25.19-2.142c0,0-10.127-11.281-24.181-2.09 c3.781-4.585,9.459-10.261,15.608-11.842c0,0-12.237-4.57-19.641,11.75c1.434-8.231,1.173-21.191-12.094-28.714 c0,0,7.419,15.919,8.147,29.129c-0.431-2.344-1.294-4.794-3.572-7.17c-7.015-7.319-13.114-7.929-13.114-7.929 s9.726,10.778,14.505,20.975c-2.753-3.294-7.605-7.512-15.42-7.252c-18.3,0.61-22.264,11.59-22.264,11.59 c7.586-3.194,19.625-4.785,28.958-3.996c-12.049,2.123-16.33,17.134-16.33,17.134c9.675-12.064,20.235-14.024,24.451-14.311 c-7.702,6.371-7.233,18.104-7.233,18.104c1.79-6.605,8.724-14.133,12.103-17.507c9.098,9.843,10.175,20.907,10.175,20.907 s1.991-3.329,1.073-10.104c-0.868-6.396-4.882-10.595-7.945-13.062c16.064,2.214,26.546,13.866,26.546,13.866 C283.008,227.773,269.855,225.777,263.302,225.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M473.655,88.275H38.345c-20.482,0-37.21,16.06-38.287,36.273v262.903 c1.077,20.214,17.805,36.273,38.287,36.273h435.31c21.177,0,38.345-17.167,38.345-38.345V126.62 C512,105.442,494.833,88.275,473.655,88.275z M494.403,406.068H17.714V105.93h476.69L494.403,406.068L494.403,406.068z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF965A"
    },
    points: "238.126,277.332 246.219,263.356 312.702,261.884 308.288,280.275 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4173CD"
    },
    d: "M202.307,273.654c6.664,26.153,26.631,56.353,53.75,70.621c27.119-14.268,47.086-44.468,53.75-70.621 H202.307z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M211.919,300.137c0,0,19.255-0.953,30.823,3.797c2.89,1.186,3.264,5.09,0.654,6.807 c-5.635,3.708-13.822,10.09-13.822,15.88L211.919,300.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M245.759,335.447c-0.736-7.357,5.773-12.707,14.712-16.184c11.586-4.505,5.241-11.678-0.552-16.367 c-6.909-5.592,2.023-7.172,39.54-7.908l-18.391,28.69l-25.011,20.598L245.759,335.447z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M256.057,349.267l-2.056-1.086c-35.014-18.414-58.535-62.535-58.535-92.181 s23.521-73.768,58.535-92.181l2.056-1.086l2.056,1.086c35.012,18.414,58.535,62.535,58.535,92.181s-23.521,73.768-58.535,92.181 L256.057,349.267z M256.057,172.749c-31.057,17.535-51.763,56.759-51.763,83.25s20.707,65.716,51.763,83.25 c31.057-17.535,51.763-56.759,51.763-83.25S287.114,190.283,256.057,172.749z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A54B37"
    },
    d: "M274.816,306.388c-0.405,0-0.81-0.108-1.173-0.337c-11.996-7.539-18.874-20.018-18.874-34.237 v-40.642c0-1.219,0.988-2.207,2.207-2.207s2.207,0.988,2.207,2.207v40.642c0,12.668,6.125,23.785,16.806,30.496 c1.035,0.651,1.345,2.013,0.698,3.043C276.265,306.022,275.549,306.388,274.816,306.388z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A54B37"
    },
    cx: 256.98,
    cy: 231.309,
    r: 4.828
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGu);
export default __webpack_public_path__ + "static/media/gu.93aa2c6b02af903bef51c6ef9b53e874.svg";
export { ForwardRef as ReactComponent };